import { useTranslation } from 'react-i18next';

import { MessageWrapper } from '../../styles';

import { Icon } from '@/components/Icon';

export const ExamGroupsWarning = () => {
  const { t } = useTranslation('StudentOnboardingPageTranslations');
  return (
    <MessageWrapper>
      <Icon i="Information" color="purple6" />
      <span>{t('EXAM_GROUPS_WARNING')}</span>
    </MessageWrapper>
  );
};
